<template>
  <v-layout justify-center row wrap>
    <v-item-group>
      <div v-if="nodes.length < 98">
        <v-item v-for="(n, index) in nodes" :key="n">
          <v-chip v-if="index < 15" outline disabled slot-scope="{}">{{
            n
          }}</v-chip>
        </v-item>
        <span v-if="nodes.length > 15">(+{{ nodes.length - 15 }}...)</span>
        <v-spacer></v-spacer>
      </div>
    </v-item-group>
  </v-layout>
</template>

<script>
export default {
  data: () => ({}),
  computed: {
    nodes: {
      get() {
        return this.$store.state.nodes;
      },
      set(value) {
        this.$store.commit("setNodes", value);
      },
    },
    select_language() {
      return this.$store.state.select_language;
    },
  },
};
</script>
